import { render, staticRenderFns } from "./NodeAllocationPage.vue?vue&type=template&id=c3a91e8a&scoped=true&"
import script from "./NodeAllocationPage.vue?vue&type=script&lang=js&"
export * from "./NodeAllocationPage.vue?vue&type=script&lang=js&"
import style0 from "./NodeAllocationPage.vue?vue&type=style&index=0&id=c3a91e8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a91e8a",
  null
  
)

export default component.exports